module.exports = "/_next/static/images/uv-light-desktop-0808417a0a102568dea2b7b85fdc2505.jpg";